/**
 * returns classic IE version or -1, if browser is not Internet Explorer
 */

function getUserAgent(): string {
  const defaultAgent = ''
  try {
    // try/catch required for node.js env
    return window && window.navigator && window.navigator.userAgent
      ? window.navigator.userAgent
      : defaultAgent
  } catch (error) {
    return defaultAgent
  }
}

export function getClassicIEVersion(): number {
  const ua = getUserAgent()
  let version = -1

  const msie = ua.indexOf('MSIE ')
  if (msie > 0) {
    // for IE 10 or older => return version number
    version = parseInt(ua.substring(msie + 5, ua.indexOf('.', msie)), 10)
  }

  const trident = ua.indexOf('Trident/')
  if (trident > 0) {
    // for IE 11 => return version number
    const rv = ua.indexOf('rv:')
    version = parseInt(ua.substring(rv + 3, ua.indexOf('.', rv)), 10)
  }

  return version
}

export function convertNodeListToArray(nodeList: NodeList): Element[] {
  return Array.prototype.slice.call(nodeList)
}

// returns Edge version or -1, if browser is not Edge
export function getEdgeVersion(): number {
  const ua = getUserAgent()
  let version = -1

  const trident = ua.indexOf('Trident/')
  if (trident > 0) {
    // for IE 11 => return version number
    const rv = ua.indexOf('rv:')
    version = parseInt(ua.substring(rv + 3, ua.indexOf('.', rv)), 10)
  }

  return version
}

// returns version of IE or -1, if browser is not Internet Explorer
export function getIEVersion(): number {
  let version = getClassicIEVersion()
  if (version === -1) {
    version = getEdgeVersion()
  }

  return version
}

export enum OSType {
  Unknown,
  Windows,
  Mac,
  Unix,
  Linux,
}

// returns operating system
export function getOSType(): OSType {
  const userAgent = getUserAgent()
  let osType = OSType.Unknown
  if (userAgent.indexOf('Windows') !== -1) {
    osType = OSType.Windows
  } else if (userAgent.indexOf('Mac') !== -1) {
    osType = OSType.Mac
  } else if (userAgent.indexOf('X11') !== -1) {
    osType = OSType.Unix
  } else if (userAgent.indexOf('Linux') !== -1) {
    osType = OSType.Linux
  }

  return osType
}
